export default __webpack_public_path__ + "static/media/mrw-sollana.397e0303.svg";